import styled from "styled-components";
export const ActionContainer = styled.div`
    display: flex;
    & .link{
        margin-right:32px;
        font-weight: 900;
        line-height: 24px;
        color: #008CFF;
    }

`